/**
 * Mirrors the secondary links bar (sections/wrb-header-utility.liquid) into Horizon's mobile
 * menu drawer, so on mobile they live in the hamburger menu instead of a bar above the header.
 * Single source of truth: the links are edited only in the "WRB · Menú secundario" section.
 */
function mirrorUtilityLinks() {
  const source = document.querySelector('.wrb-utility__list');
  const target = document.querySelector('.menu-drawer__utility-links');
  if (!source || !target) return false;

  target.querySelector('.wrb-drawer-links')?.remove();

  const list = document.createElement('ul');
  list.className = 'wrb-drawer-links';
  list.setAttribute('role', 'list');

  source.querySelectorAll('a').forEach((link) => {
    const item = document.createElement('li');
    const copy = document.createElement('a');
    copy.href = link.getAttribute('href') ?? '#';
    copy.textContent = link.textContent?.trim() ?? '';
    item.append(copy);
    list.append(item);
  });

  target.prepend(list);
  return true;
}

// Horizon stamps (and may re-render) the drawer after our module runs: re-mirror whenever
// the drawer exists without our links. Cheap check, so the observer can stay connected.
function ensureMirrored() {
  if (!document.querySelector('.menu-drawer__utility-links .wrb-drawer-links')) mirrorUtilityLinks();
}

ensureMirrored();
new MutationObserver(ensureMirrored).observe(document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', mirrorUtilityLinks);
